'use client';

import styles from './styles/modals.module.css';

export default function VideoModal({
  isOpen,
  onClose,
  content
}) {
  if (!isOpen) return null;

  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <span className={styles.close} onClick={onClose}>&times;</span>
        <h2>Course Introduction Video</h2>

        <div className={styles.videoContainer}>
          {content ? (
            <video
              src={content}
              controls
              autoPlay
              className={styles.videoElement}
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            <p className={styles.error}>No video URL provided.</p>
          )}
        </div>
        
      </div>
    </div>
  );
}